import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAdminAxiosInstance } from "../../../../api/Admin";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  isEdit: false,
  showCreateModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedId: "",
  isLoading: false,

  /** Plan artwork. English and Arabic are separate files, not one image flipped. */
  imagePreview: "",
  imageName: "",
  aliasImagePreview: "",
  aliasImageName: "",
  isImageUploading: false,
  isAliasImageUploading: false,

  editPlanData: {},

  /**
   * Last answer from subscription-plan/preview. The builder shows the selling price and each
   * item's redemption price from this rather than working them out locally - the list prices
   * come from the catalog, so the service is the only thing that can price a plan.
   */
  pricing: {},
  isPricingLoading: false,
};

export const getSubscriptionPlanEditData = createAsyncThunk(
  "subscriptionPlan/details",
  async (id, { rejectWithValue }) => {
    const api = await getAdminAxiosInstance();
    try {
      const response = await api.get(
        `/subscription-plan/details?plan_id=${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const subscriptionPlanSlice = createSlice({
  name: "subscriptionPlan",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSubscriptionPlanEditData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSubscriptionPlanEditData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.editPlanData = action.payload?.data;
      })
      .addCase(getSubscriptionPlanEditData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { updateConfig } = subscriptionPlanSlice.actions;
export default subscriptionPlanSlice.reducer;
